<template>
  <div class="user_con_main">
    <!-- 购买作品组件 -->
    <PayWork v-if="show_paywork" :textlength="textlength" :wkid="wkid" @hide="show_paywork = false" @success="successPay" />
   
    <div class="flex_ali fr" v-if="batch_state">
      <div class="batch_btn" @click="batch_state=false">取消</div>
      <div class="batch_btn" @click="getBatchWorks()">完成</div>
    </div>
    <div class="fr batch_btn" @click="batch_state=true" v-else>批量导出MP3</div>
    <div class="order" v-if="work_list.length==0">
      <img src="../../assets/images/null.png" alt="">
    </div>
    <div class="user_real_list" v-else>
      <div class="user_real_li" v-for="(item, index) in work_list" :key="index">
        <div class="batch_icon" v-if="batch_state">
          <img src="../../assets/images/img2/fp_off.png" @click="addBatchWorks(index)" v-if="!judgeBatchWorks(index)">
          <img src="../../assets/images/img2/fp_on.png" v-else @click="addBatchWorks(index)">
        </div>
        <div class="user_real_top">
          <div class="flex_ali">
            <img :src="item.headpath" class="user_avater" />
            <div>
              <p class="user_real_tit">
                {{ item.wkname ? item.wkname : "未命名作品" }}
              </p>
              <p class="user_real_desp">
                主播：{{ item.voiceauthor }} &nbsp&nbsp
              </p>
            </div>
          </div>
          <div class="user_real_r user_workbtn" :class="
              playListAudio.audiourl == item.musicpath ? 'user_workbtn_act' : ''
            " @click="playListAudio.play(item.musicpath)">
            <img src="../../assets/images/play.png" class="user_work_play" v-if="playListAudio.audiourl != item.musicpath" />
            <img src="../../assets/images/pause.png" class="user_work_play" v-else />
            <span>{{
              playListAudio.audiourl != item.musicpath ? "播放" : "暂停"
            }}</span>
          </div>
        </div>
        <div class="user_work_btnlist">
          <div class="user_work_fbtn" @click="isRemoveWork(item.wkid)">
            删除作品
          </div>
          <div class="user_work_fbtn" @click="againEditor(item)">重新编辑</div>
          <div class="user_work_fbtn" @click="downloadDub(item)">导出MP3</div>
          <div class="user_work_fbtn" @click="downloadMp4(item)">导出MP4</div>
        </div>
      </div>
    </div>
    <div class="flex_aro_h">
      <el-pagination background layout="prev, pager, next" :total="total" @current-change="changeWoeks">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import PlayListAudio from "../../utils/PlayListAudio.js";
// 购买作品组件
import PayWork from "../../components/pay_work.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      page: 1, //当前页数
      work_list: [], //作品列表
      total: 0, //数据总数
      playListAudio: new PlayListAudio(),
      show_paywork: false, // 购买作品组件显示状态
      textlength: 0, //导出作品文本长度
      wkid: "", //导出作品的id
      batch_state: false,// 批量导出状态
      batch_list: [],// 批量导出列表
    };
  },
  components: {
    PayWork,
  },
  computed: {
    ...mapState(["userrich", "allMusic"]),
  },
  mounted() {
    this.getWorks();
  },
  destroyed() {
    this.playListAudio.stop();
  },
  methods: {
    // 批量下载文件
    downloadFile(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";  // 防止影响页面
      iframe.style.height = 0;  // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);  // 这一行必须，iframe挂在到dom树上才会发请求
      // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    // 确定批量下载文件
    getBatchWorks() {
      if (this.batch_list.length === 0) {
        this.batch_state = false
        this.batch_list = []
        return
      }
      this.$confirm('确认下载这些文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(1)
        let list = []
        this.batch_list.forEach(item=>{
          console.log(item,this.work_list[item].musicpath)
          list.push(this.work_list[item].musicpath)
        })
        console.log(list)
        list.forEach(url => {
          this.downloadFile(url);
        })
        this.batch_state = false
        this.batch_list = []
      })
    },
    // 判断元素是否在数组内
    judgeBatchWorks(bz) {
      const index = this.batch_list.indexOf(bz)
      return (index >= 0)
    },
    // 添加批量导出作品
    addBatchWorks(bz) {
      const index = this.batch_list.indexOf(bz)
      if (index >= 0) {
        this.batch_list.splice(index, 1)
        return
      }
      this.batch_list.push(bz)
    },
    //  购买作品成功
    successPay() {
      this.show_paywork = false
      this.getWorks();
    },
    // 分页点击事件
    changeWoeks(e) {
      this.page = e;
      this.getWorks();
      this.$globalFun.goTop();
    },
    // 获取作品列表
    getWorks() {
      let self = this;
      let json = {
        page: this.page,
        rows: 10,
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryworklist;
      this.$request.postHttp(json, url, (decData) => {
        self.work_list = decData.model.list;
        self.total = decData.model.total;
      });
    },
    // 确认删除弹窗
    isRemoveWork(wkid) {
      let self = this;
      this.$confirm("此操作将永久删除该作品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        self.removeWork(wkid);
      });
    },
    // 修改作品
    removeWork(wkid) {
      let self = this;
      let json = {
        wkid: wkid,
        status: "0",
      };
      let url = self.$store.state.app_api + self.$store.state.app_url.uptwork;
      this.$request.postHttp(json, url, (decData) => {
        console.log(decData);
        self.getWorks();
      });
    },
    // 重新编辑
    againEditor(item) {
      let bg_music = this.$globalFun.detection(this.allMusic, item.bgmusic) ? this.$globalFun.detection(this.allMusic, item.bgmusic) : {};
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryzhubodetail;
      this.$request.postHttp({ zbid: item.zbid }, url, (decData) => {
        this.$store.commit("setAnchor", decData.model);
        this.$router.push({
          path: "/make",
          query: {
            workinfo: JSON.stringify(item),
            bg_music: bg_music,
          },
        });
      });
    },
    // 验证vip状态权限
    judgeVipState(item) {
      console.log(item);
      // 是否是普通会员
      let isvalidvip = this.userrich.isvalidvip == "1";
      // 是否是超级会员
      let isvalidsvip = this.userrich.isvalidsvip == "1";
      // 作品主播是否是金牌主播
      let feature = item.feature == "1";
      if (!isvalidvip && !isvalidsvip && item.crgstatus == '0') {
        //非会员无法导出作品
        this.show_paywork = true;
        this.textlength = parseInt(item.txtnum);
        this.wkid = item.wkid;
        return false;
      } else if (feature && !isvalidsvip) {
        // 普通会员无法导出金牌主播作品
        this.$globalFun.goToOpenVip(
          this,
          "普通会员无法导出金牌主播作品，是否前往开通超级会员"
        );
        return false;
      } else {
        return true;
      }
    },
    //导出mp3
    downloadDub(item) {
      if (!this.judgeVipState(item)) return;
      this.$globalFun.downloadDub(item.musicpath);
    },
    //导出mp4
    downloadMp4(item) {
      if (!this.judgeVipState(item)) return;
      const loading = this.$loading({
        lock: true,
        text: "导出中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        customClass: "make_loding",
      });
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.ttschangemp4app;
      this.$request.postHttp({ mp3url: item.musicpath }, url, (decData) => {
        loading.close();
        window.open(decData.model.mp4url);
      });
    },
  },
};
</script>

<style>
@import url("../../assets/css/user.css");
</style>


// WEBPACK FOOTER //
// src/view/user/user_works.vue